import type {
	MenuItemLinks,
	NavBarItem,
	NavBarLinkItem,
	NavBarMenuItem,
	NavCta,
} from '@ds-mgnl/marketing';

export const topNavData: NavBarItem[] = [
	{
		type: 'submenu',
		label: 'Capabilities',
		items: [
			{
				type: 'links',
				linkGroups: [
					{
						label: '',
						links: [
							{
								label: 'Business Development',
								path: '/capabilities/business-development',
								value: '/capabilities/business-development',
								openInNewTab: false,
							},
							{
								label: 'Clinical Review',
								path: '/capabilities/clinical-review',
								value: '/capabilities/clinical-review',
								openInNewTab: false,
							},
							{
								label: 'Intake Operations',
								path: '/capabilities/intake-operations',
								value: '/capabilities/intake-operations',
								openInNewTab: false,
							},
							{
								label: 'Reimbursement',
								path: '/capabilities/reimbursement',
								value: '/capabilities/reimbursement',
								openInNewTab: false,
							},
						],
					},
				],
			} as MenuItemLinks,
		],
	} as NavBarMenuItem,
	{
		type: 'submenu',
		label: 'Features',
		items: [
			{
				type: 'links',
				linkGroups: [
					{
						label: '',
						links: [
							{
								label: 'Platform Overview',
								path: '/features/platform-overview',
								value: '/features/platform-overview',
								openInNewTab: false,
							},
							{
								label: 'Integrations',
								path: '/features/integrations',
								value: '/features/integrations',
								openInNewTab: false,
							},
							{
								label: 'Mobile App',
								path: '/features/mobile-app',
								value: '/features/mobile-app',
								openInNewTab: false,
							},
						],
					},
				],
			} as MenuItemLinks,
		],
	} as NavBarMenuItem,
	{
		type: 'submenu',
		label: 'Who We Serve',
		items: [
			{
				type: 'links',
				linkGroups: [
					{
						label: '',
						links: [
							{
								label: 'Homecare',
								path: '/who-we-serve/homecare',
								value: '/who-we-serve/homecare',
								openInNewTab: false,
							},
							{
								label: 'Hospice',
								path: '/who-we-serve/hospice',
								value: '/who-we-serve/hospice',
								openInNewTab: false,
							},
							{
								label: 'Skilled Nursing',
								path: '/who-we-serve/skilled-nursing',
								value: '/who-we-serve/skilled-nursing',
								openInNewTab: false,
							},
						],
					},
				],
			} as MenuItemLinks,
		],
	} as NavBarMenuItem,
	{
		type: 'submenu',
		label: 'Resources',
		items: [
			{
				type: 'links',
				linkGroups: [
					{
						label: '',
						links: [
							{
								label: 'Customer Stories',
								path: '/resources/case-studies',
								value: '/resources/case-studies',
								openInNewTab: false,
							},
							{
								label: 'Expertise',
								path: '/resources/blogs',
								value: '/resources/blogs',
								openInNewTab: false,
							},
							{
								label: 'Support',
								path: '/contact/support',
								value: '/contact/support',
								openInNewTab: false,
							},
						],
					},
				],
			} as MenuItemLinks,
		],
	} as NavBarMenuItem,
	{
		type: 'link',
		link: {
			label: 'Contact',
			path: '/contact',
			value: '/contact',
			openInNewTab: false,
		},
	} as NavBarLinkItem,
];

export const ctaLinks: NavCta[] = [
	{
		path: '/contact/request-pac-iq-demo',
		label: 'Demo',
		value: '/contact/request-pac-iq-demo',
		openInNewTab: false,
	},
	{
		path: 'sign-in',
		label: 'Sign in',
		value: 'https://www.referral-iq.com/',
		openInNewTab: true,
	},
];
